import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import LinkBar from "../../LinkBar/LinkBar";
import Search from "../Search/Search";

const Departments = () => {
  const { series, dept } = useParams();
  const [semesters, setSemesters] = useState([]);

  useEffect(() => {
    series &&
      dept &&
      fetch("https://apichothaon1-hzrifat.b4a.run/semesters")
        .then((res) => res.json())
        .then((data) =>
          setSemesters(
            data?.map((d) => {
              return d?.code;
            })
          )
        );
  }, [series, dept]);

  return (
    <div className="container row">
      <div className="col-md-4 col-sm-6 col-12 ms-0 ps-0">
        <Search />
      </div>
      <div className="col-md-8 col-sm-6 col-12">
        <LinkBar series={series} dept={dept} />
        <div className="row mt-5 mb-4 ">
          {semesters?.length
            ? semesters?.map((s, i) => {
                return (
                  <div
                    key={i}
                    className="col-md-3 col-sm-6 col-12 d-flex justify-content-center"
                  >
                    <Link
                      style={{ textDecoration: "none" }}
                      exact
                      to={`/collections/${series}/${dept}/${s}`}
                    >
                      <div className="folder-style">
                        <i
                          style={{ fontSize: "5rem" }}
                          className="fa-solid fa-folder"
                        ></i>
                        <p style={{ fontWeight: "500", fontSize: "1.1rem" }}>
                          {s?.toString()?.split("")?.join("-")}
                        </p>
                      </div>
                    </Link>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    </div>
  );
};

export default Departments;
